import React, { useState, useEffect } from "react";

import Input from "../../components/FormComponents/Input";
import ErrorMessage from "../../components/FormComponents/ErrorMessage";
import Button from "../../components/FormComponents/Button";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import { useAxiosContext } from "../../context/AxiosContext";

const AddChart = ({ handleSave }) => {
  const [charName, setChartName] = useState("");
  const [error, setError] = useState("");
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrganisations, setSelectedOrganisations] = useState({});
  const { axiosInstance, handleError } = useAxiosContext();

  const setErrorCallback = (error) => {
    setError(error);
  };
  const fetchOrganisations = async () => {
    try {
      const { data } = await axiosInstance.get(`/organisations`);
      setOrganisations(data);
    } catch (error) {
      handleError(error);
    }
  };

  const handleSelectChange = (id) => {
    if (id) {
      const org = organisations.find((org) => org.id === id);
      setSelectedOrganisations(org);
    } else {
      setSelectedOrganisations({});
    }
  };
  useEffect(() => {
    fetchOrganisations();

    //eslint-disable-next-line
  }, []);

  return (
    <div className="add_theme_container">
      <div className="builder_form">
        <Input
          label="Name"
          placeholder="Enter chart name"
          value={charName}
          name="name"
          onChange={(e) => setChartName(e.target.value)}
        />

        {error && <ErrorMessage>{error}</ErrorMessage>}
      </div>
      <SingleSelectBox
        selectedData={selectedOrganisations?.id || ""}
        options={organisations || []}
        onChange={(obj) => handleSelectChange(obj.id)}
        placeholder="Select Organization"
        label="Organization"
        isSearch={true}
      />
      <div>
        <Button onClick={() => handleSave({ name: charName, setErrorCallback, organization: selectedOrganisations })}>
          Add Chart
        </Button>
      </div>
    </div>
  );
};

export default AddChart;
